module.exports = __webpack_public_path__ + "media/icons/firma-grey@3x-d88b6c30.svg";